import { URL_REGEX } from 'constants/RegExs'

const regex = new RegExp(URL_REGEX, 'gi')

export const mapTextToContentArray = (text: string) => {
  regex.lastIndex = 0

  const result: Array<{ type: 'text' | 'link'; content: string }> = []

  let lastIndex = 0
  let match: RegExpExecArray | null = regex.exec(text)

  while (match !== null) {
    const url = match[0]

    if (match.index > lastIndex) {
      result.push({
        type: 'text',
        content: text.slice(lastIndex, match.index),
      })
    }

    const trimmedUrl = url.replace(/[.,!?;:]+$/, '')

    result.push({
      type: 'link',
      content: trimmedUrl,
    })

    lastIndex = match.index + trimmedUrl.length

    match = regex.exec(text)
  }

  if (lastIndex < text.length) {
    result.push({
      type: 'text',
      content: text.slice(lastIndex),
    })
  }

  return result
}
